import { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { UpdateCompanyConfigurationAction } from "../../../../../store/Ancillary/CompanyDetails/Action";

const CompanyRefNo = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [inputData, setInputData] = useState({
    gst_no: "",
    msme_flag: false,
    msme_no: "",
  });

  const [errors, setErrors] = useState({});
  const { company_config_data } = useSelector(
    (state) => state?.AncillaryReducer?.CompanyConfigReducer,
  );
  const validate = () => {
    let temp = {};

    if (!inputData.gst_no) temp.gst_no = "GST Number is required";

    if (inputData.msme_flag && !inputData.msme_no) {
      temp.msme_no = "MSME Number is required";
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === "msme_flag") {
      setInputData({
        ...inputData,
        [name]: value === "yes" ? true : false,
      });
      setErrors((prev) => {
        return { ...prev, msme_no: "" };
      });
    } else {
      setInputData({
        ...inputData,
        [name]: value,
      });
    }
    if (Object.values(errors).some((x) => x !== "")) {
      validate({
        ...inputData,
        [name]: value,
      });
    }
  };
  const handleSubmit = () => {
    if (validate()) {
      dispatch(
        UpdateCompanyConfigurationAction({
          ...inputData,
          bank_details_json: company_config_data?.bank_details
            ? JSON.stringify(company_config_data?.bank_details)
            : null,
        }),
      );
    }
  };
  useEffect(() => {
    company_config_data && setInputData({ ...company_config_data });
  }, [company_config_data]);
  return (
    <Box>
      <Paper className={classes.Paper}>
        <Grid container spacing={2} rowSpacing={2.5} alignItems={"flex-end"}>
          <Grid item container alignItems={"flex-end"}>
            <Grid item xs={12} md={4}>
              <Typography sx={{ fontWeight: 600 }}>Is MSME</Typography>

              <FormControl>
                <RadioGroup
                  row
                  name="msme_flag"
                  value={inputData.msme_flag ? "yes" : "no"}
                  onChange={handleInput}
                  sx={{ height: "38px" }}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid>
            {/* MSME FIELD (CONDITIONAL) */}
            {inputData.msme_flag && (
              <Grid item xs={12} md={8}>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    label="MSME Number"
                    name="msme_no"
                    value={inputData.msme_no}
                    onChange={handleInput}
                    required
                    {...(errors.msme_no && {
                      error: true,
                      helperText: errors.msme_no,
                    })}
                  />
                </FormControl>
              </Grid>
            )}
          </Grid>

          {/* GST FIELD */}
          <Grid item xs={12} md={9}>
            <Typography sx={{ fontWeight: 600 }}>GST Number</Typography>
            <FormControl fullWidth>
              <TextField
                size="small"
                placeholder="Enter GST Number"
                name="gst_no"
                value={inputData.gst_no}
                onChange={handleInput}
                required
                {...(errors.gst_no && {
                  error: true,
                  helperText: errors.gst_no,
                })}
              />
            </FormControl>
          </Grid>

          {/* SAVE BUTTON */}
          <Grid
            item
            xs={12}
            md={3}
            pb={"1px"}
            display={"flex"}
            justifyContent={"end"}
          >
            <Box>
              <Button
                variant="contained"
                onClick={handleSubmit}
                className="mpl-primary-btn"
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    Paper: {
      boxShadow:
        theme.palette.mode === "dark"
          ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
          : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
      padding: "20px 40px 20px 40px",
      borderRadius: "16px",
      backgroundColor: "#f3edfd",
      minHeight: "184px",
    },
  }),
);

export default CompanyRefNo;
